// components/marketer/Login.jsx
import { useState } from "react";
import { Eye, EyeOff, Mail, Lock } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function MarketerLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const login = async () => {
    if (!form.email || !form.password) {
      toast.error("Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}marketer/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      const data = await res.json();

      if (data.success) {
        toast.success("Login successful! Welcome back");
        localStorage.setItem("token", data.token);
        localStorage.setItem("userType", "marketer");
        setTimeout(() => {
          window.location.href = "/marketerdashboard";
        }, 1500);
      } else {
        toast.error(data.message || "Login failed");
      }
    } catch (err) {
      toast.error("Network error. Check your connection");
    }
    setLoading(false);
  };

  return (
    <>
      <Toaster position="top-center" richColors />
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-orange-100 to-red-600 flex items-center justify-center p-6">
        <div className="bg-white rounded-2xl shadow-2xl p-10 w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-purple-700">Marketer Login</h1>
            <p className="text-gray-600 mt-2">Access your earnings dashboard</p>
          </div>

          <div className="space-y-6">
            <div className="relative">
              <Mail className="absolute left-4 top-4 w-6 h-6 text-gray-400" />
              <input
                type="email"
                placeholder="Email Address"
                className="w-full pl-14 pr-4 py-4 border-2 border-gray-200 rounded-xl focus:border-purple-500 focus:outline-none transition"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>

            <div className="relative">
              <Lock className="absolute left-4 top-4 w-6 h-6 text-gray-400" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="w-full pl-14 pr-12 py-4 border-2 border-gray-200 rounded-xl focus:border-purple-500 focus:outline-none transition"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-4 text-gray-500 hover:text-purple-600 transition"
              >
                {showPassword ? <EyeOff className="w-6 h-6" /> : <Eye className="w-6 h-6" />}
              </button>
            </div>

            <button
              onClick={login}
              disabled={loading}
              className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-5 rounded-xl font-bold text-xl hover:from-purple-700 hover:to-pink-700 transition disabled:opacity-70 flex items-center justify-center gap-3"
            >
              {loading ? (
                <>
                  <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                  Logging in...
                </>
              ) : (
                "Login as Marketer"
              )}
            </button>
          </div>

          <p className="text-center text-sm text-gray-600 mt-8">
            Forgot password? Contact your Admin
          </p>
        </div>
      </div>
    </>
  );
}